import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http';
import '../src/assets/main.css'
Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.$symbol = {
  'EUR': '€',
  'GBP': '£',
}
const startApp= ()=>{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
http.get('/api/users/get?me=1').then(response=>{
  store.state.auth = response.data;
  if(store.state.auth.verified.email == false && location.pathname !== '/auth') location.href = '/auth?tab=reset';
  startApp();
}).catch(error=>{
  if(location.pathname !== '/auth') location.href = '/auth';
  else startApp();
})

/* Affiliate */

var ref = (new URLSearchParams(window.location.search)).get("r");
if(ref) window.localStorage.setItem('referrerCode', ref);